
const storagePlugin = (Vue, options) => {
  const storageFn = {
    setItem(key, value = '') {
      window.localStorage.setItem(`WX_${key.toString().toUpperCase()}`, value)
    },
    getItem(key) {
      return window.localStorage.getItem(`WX_${key.toString().toUpperCase()}`) || ''
    },
    remove(key) {
      window.localStorage.removeItem(`WX_${key.toString().toUpperCase()}`)
    },
    removeAll() {
      window.localStorage.clear()
    }
  }
  Vue.prototype.$storage = storageFn
}
export default storagePlugin